import {graphql} from "babel-plugin-relay/macro";

export const MULTIPLE_CHOICE_ELEMENT_FRAGMENT = graphql`
    fragment wissenwirktMultiplechoiceElementDisplay_MultipleChoiceElementV2Fragment on MultipleChoiceLearnElement {
        question
        image {
            url
        }
        answeringType
        answerOptions {
            answer
            image {
                url
            }
        }
    }
`;
